var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 33489"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 5 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.25C0 8.83579 0.34538 8.5 0.771429 8.5H17.2286C17.6546 8.5 18 8.83579 18 9.25C18 9.66421 17.6546 10 17.2286 10H0.771429C0.34538 10 0 9.66421 0 9.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 6 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 0.5C9.66421 0.5 10 0.84538 10 1.27143L10 17.7286C10 18.1546 9.66421 18.5 9.25 18.5C8.83579 18.5 8.5 18.1546 8.5 17.7286L8.5 1.27143C8.5 0.84538 8.83579 0.5 9.25 0.5Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.7cd74e49b6acbf2b3b5363529c1c3c91.svg";
export { ForwardRef as ReactComponent };